var fetchUser;

fetchUser = {

  /*
   * Fetch user data from endpoint
   *
   * @param {String}   userId  - User snickerdoodle id
   * @param {Function} success - Success callback
   * @param {Function} [error] - Error callback (Optional)
   */
  fetch: function(userId, success, error) {
    var attributes, ref;
    userId = userId != null ? userId.replace(/"/g, '') : void 0;
    attributes = {
      service: 'user',
      userId: userId,
      country: document.head.getAttribute('data-country')
    };
    $.ajax({
      type: 'GET',
      url: ((ref = Groupon.endpoints) != null ? ref.user : void 0) || '/layout/calls/user',
      timeout: 5000,
      data: attributes,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return;
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },

  /*
   * Removes user data from browser sessionStorage
   */
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  },

  /*
   * @typedef  {Object}  userObject
   * @property {Boolean} hasUserData - Flag indicating that user data is stored
   * @property {String}  userId      - Snickerdoodle id
   */

  /*
   * Check for user data from Browser sessionStorage and process data if available
   *
   * @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
   * @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
   * @returns {Object}   userObject
   */
  useStoredData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData();
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  }
};

module.exports = {
  fetchUser: fetchUser
};

//# sourceMappingURL=data:application/json;base64,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
